var fetchUser;

fetchUser = {

  /*
   * Fetch user data from endpoint
   *
   * @param {String}   userId  - User snickerdoodle id
   * @param {Function} success - Success callback
   * @param {Function} [error] - Error callback (Optional)
   */
  fetch: function(userId, success, error) {
    var attributes, ref;
    userId = userId != null ? userId.replace(/"/g, '') : void 0;
    attributes = {
      service: 'user',
      userId: userId,
      country: document.head.getAttribute('data-country')
    };
    $.ajax({
      type: 'GET',
      url: ((ref = Groupon.endpoints) != null ? ref.user : void 0) || '/layout/calls/user',
      timeout: 5000,
      data: attributes,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return;
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },

  /*
   * Removes user data from browser sessionStorage
   */
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  },

  /*
   * @typedef  {Object}  userObject
   * @property {Boolean} hasUserData - Flag indicating that user data is stored
   * @property {String}  userId      - Snickerdoodle id
   */

  /*
   * Check for user data from Browser sessionStorage and process data if available
   *
   * @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
   * @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
   * @returns {Object}   userObject
   */
  useStoredData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData();
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  }
};

module.exports = {
  fetchUser: fetchUser
};

//# sourceMappingURL=data:application/json;base64,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
